module.exports = __webpack_public_path__ + "static/media/tgch.6bffcec3.svg";